module.exports = __webpack_public_path__ + "4cc8262a1d2f45031ca9958ea72131dd.svg";